export default __webpack_public_path__ + "static/media/plus-blue.62f5d1db.svg";